import type { Environment } from './environment.types';

// See `environment.ts` for notes on the `: Environment` annotation.
export const environment: Environment = {
  env: 'staging',
  production: false,
  // Filing-form loader UX. Available options: 'skeleton' | 'blocking'.
  // See docs/ui/loaders/filing/README.md for details on each variant.
  filingLoaderMode: 'skeleton',
  // Controls the final "Loaded in MM:SS.d" popup shown by the 'blocking'
  // loader variant after hydration completes. No effect when
  // filingLoaderMode is 'skeleton'. See docs/ui/loaders/filing/README.md.
  filingLoaderShowCompletionPopup: true,
  // Developer-only logs viewer area. The slug scopes the URL prefix
  // (/dev-{slug}/...) and MUST match the backend appsettings.json
  // DevArea:Slug value.
  // Empty string disables the dev area routes.
  devAreaSlug: 'yyc-1a3fe53426bf1f8b9ede4a11',
  // See `environment.ts` for notes on `fileSizeDecimalPrecision`.
  fileSizeDecimalPrecision: 1,
};
